import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { IpemarksService } from '../ipemarks.service';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MatSort } from '@angular/material/sort';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { IpemarksSearchComponent } from '../ipemarks-search/ipemarks-search.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ipemarks',
  templateUrl: './ipemarks.component.html',
  styleUrls: ['./ipemarks.component.scss']
})
export class IpemarksComponent implements OnInit, OnDestroy {
  maxDate: any
  issueDate: string;
  IPEMARKSForm!: FormGroup;

  dateValue: string = '';
  selectedDate: Date | null = null;
  @ViewChild('dateInput', { static: false }) dateInput!: ElementRef;
  @ViewChildren('inputRefs') inputRefs!: QueryList<ElementRef>;
  inputdate: any;

  /** Cascade filter lists (same APIs as Test Creation) */
  academicYearList: any[] = [];
  filteredAcademicYearList: any[] = [];
  academicYearQuery = '';
  classList: any[] = [];
  filteredClassList: any[] = [];
  classQuery = '';
  groupList: any[] = [];
  filteredGroupList: any[] = [];
  groupQuery = '';
  streamList: any[] = [];
  filteredStreamList: any[] = [];
  streamQuery = '';
  programList: any[] = [];
  filteredProgramList: any[] = [];
  programQuery = '';
  testTypeList: any[] = [];
  filteredTestTypeList: any[] = [];
  testTypeQuery = '';
  selectedAcademicYear = '';
  selectedClassName = '';
  selectedGroupName = '';
  selectedStreamName = '';
  selectedProgramName = '';
  selectedTestTypeLabel = '';

  testlist: any[] = [];
  filteredTestList: any[] = []; 
  listofsection: any[] = [];
  filteredSectionList: any[] = [];
  buildinglist: any[] = [];
  filteredBuildingList: any[] = [];
  stream: any;
  group: any;
  class: any;
  program: any;
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  IPEmarks:any;
  selectedSectionId: any;
  selectedtestname = '';
  selectedBuildingName = '';
  selectedSectionName = '';
  noSectionFound = false;
  testQuery = '';
  buildingQuery = '';
  sectionQuery = '';
  private flatpickrInstance: any;
  private datePickerRetries = 0;
  private lastLoadedFilterKey = '';
  private sort?: MatSort;
  @ViewChild(MatSort) set matSort(sort: MatSort | undefined) {
    if (sort) {
      this.sort = sort;
      this.dataSource.sort = sort;
    }
  }
  selectedTestCode: any;
  testWiseSubjects: any;
  students: any;
  studentData: any
  displayLabels: any
  testdate: any;
  testname1: any;
  data2: any
  buildingId: any;
  classid: any;
  subjectVisibility: { [key: string]: boolean } = {};
  private marksBeforeNc: { [key: string]: any } = {};
  private originalStudentMarks = new Map<string, { [subject: string]: string }>();
  tableHeight = '';
  section: any;
  isFilterPanelOpen = true;
  private searchDialogRef: MatDialogRef<IpemarksSearchComponent> | null = null;

  /** True when at least one student’s marks differ from the loaded values. */
  get hasStudentMarksChanges(): boolean {
    return (this.dataSource?.data || []).some((student: any) => this.isStudentMarksChanged(student));
  }

  get canSubmitMarks(): boolean {
    return this.hasStudentMarksChanges;
  }

  get submitMarksTitle(): string {
    if (!this.hasStudentMarksChanges) {
      return 'Enter marks for at least one student to enable Submit';
    }
    return '';
  }

  constructor( private services: IpemarksService, private fb: FormBuilder,private toast:ToastmessageService,private dialog: NgDialogAnimationService,private spinner: NgxSpinnerService,private dailog12:MatDialog, private cdr: ChangeDetectorRef) {
   
   }
  
  monthWiseDetails: any[] = [];


  ngOnInit(): void {
    this.dataSource.sortingDataAccessor = (row: any, property: string) => {
      if (property === 'admNo' || property === 'studentName') {
        return (row[property] ?? '').toString().toLowerCase();
      }
      const cell = row[property];
      return (cell?.marks ?? '').toString().toLowerCase();
    };
    this.IPEMARKSForm = this.fb.group({
      academicYear: ['', Validators.required],
      academicYearId: [''],
      className: ['', Validators.required],
      classId: [''],
      groupName: ['', Validators.required],
      groupId: [''],
      streamName: ['', Validators.required],
      streamId: [''],
      programName: ['', Validators.required],
      programId: [''],
      testType: ['', Validators.required],
      testTypeCode: [''],
      testCode: ['', Validators.required],
      Building: ['', Validators.required],
      Section: ['', Validators.required]
    });
    this.loadAcademicYears();
    this.loadTestTypes();
  }

  toggleFilterPanel(): void {
    this.isFilterPanelOpen = !this.isFilterPanelOpen;
    this.cdr.detectChanges();
  }

  /** Collapse filter panel after Search so marks table gets full width. */
  private collapseFilterAfterSearch(): void {
    this.isFilterPanelOpen = false;
    this.cdr.detectChanges();
  }

  ontestcode(e:any){
this.selectedTestCode=e.target.value
  }
  loadAcademicYears(): void {
    this.spinner.show();
    this.services.getAcademicYears().subscribe({
      next: (res: any) => {
        this.academicYearList = this.normalizeAcademicYearList(res);
        this.academicYearQuery = '';
        this.filteredAcademicYearList = [...this.academicYearList];
        this.spinner.hide();
      },
      error: () => {
        this.academicYearList = [];
        this.filteredAcademicYearList = [];
        this.spinner.hide();
      }
    });
  }

  loadTestTypes(): void {
    this.services.getTestTypes().subscribe({
      next: (res: any) => {
        this.testTypeList = this.normalizeList(res, ['testTypes', 'testTypeList', 'types', 'data']);
        this.testTypeQuery = '';
        this.filteredTestTypeList = [...this.testTypeList];
      },
      error: () => {
        this.testTypeList = [];
        this.filteredTestTypeList = [];
      }
    });
  }

  loadClasses(academicYear?: string): void {
    const year = academicYear || this.IPEMARKSForm?.value?.academicYear;
    if (!year) {
      this.classList = [];
      this.filteredClassList = [];
      return;
    }
    this.services.getClassestest(year).subscribe({
      next: (res: any) => {
        this.classList = this.normalizeList(res, ['classes', 'classList', 'data']);
        this.classQuery = '';
        this.filteredClassList = [...this.classList];
      },
      error: () => {
        this.classList = [];
        this.filteredClassList = [];
      }
    });
  }

  loadGroups(classId?: any): void {
    const academicYear = this.IPEMARKSForm?.value?.academicYear;
    const id = classId ?? this.IPEMARKSForm?.value?.classId;
    if (!academicYear || (id !== 0 && !id)) {
      this.groupList = [];
      this.filteredGroupList = [];
      return;
    }
    this.services.getGroups(academicYear, id).subscribe({
      next: (res: any) => {
        this.groupList = this.normalizeList(res, ['groups', 'groupList', 'data']);
        this.groupQuery = '';
        this.filteredGroupList = [...this.groupList];
      },
      error: () => {
        this.groupList = [];
        this.filteredGroupList = [];
      }
    });
  }

  loadStreams(groupId?: any): void {
    const academicYear = this.IPEMARKSForm?.value?.academicYear;
    const classId = this.IPEMARKSForm?.value?.classId;
    const id = groupId ?? this.IPEMARKSForm?.value?.groupId;
    if (!academicYear || (classId !== 0 && !classId) || (id !== 0 && !id)) {
      this.streamList = [];
      this.filteredStreamList = [];
      return;
    }
    this.services.getStreams(academicYear, classId, id).subscribe({
      next: (res: any) => {
        this.streamList = this.normalizeList(res, ['streams', 'streamList', 'data']);
        this.streamQuery = '';
        this.filteredStreamList = [...this.streamList];
      },
      error: () => {
        this.streamList = [];
        this.filteredStreamList = [];
      }
    });
  }

  loadPrograms(streamId?: any): void {
    const academicYear = this.IPEMARKSForm?.value?.academicYear;
    const classId = this.IPEMARKSForm?.value?.classId;
    const id = streamId ?? this.IPEMARKSForm?.value?.streamId;
    const groupId = this.IPEMARKSForm?.value?.groupId;
    
    if (!academicYear || (classId !== 0 && !classId) || (id !== 0 && !id)) {
      this.programList = [];
      this.filteredProgramList = [];
      return;
    }
    this.services.getProgramNames(academicYear, classId,groupId, id).subscribe({
      next: (res: any) => {
        this.programList = this.normalizeList(res, ['programs', 'programList', 'programNames', 'data']);
        this.programQuery = '';
        this.filteredProgramList = [...this.programList];
      },
      error: () => {
        this.programList = [];
        this.filteredProgramList = [];
      }
    });
  }

  loadIpeTestNames(): void {
    const v = this.IPEMARKSForm?.value || {};
    const academicId = v.academicYearId;
    const classId = v.classId;
    const groupId = v.groupId;
    const streamId = v.streamId;
    const programId = v.programId;
    const testType = v.testTypeCode || this.toApiTestType(v.testType);
    if (
      (academicId !== 0 && !academicId) ||
      (classId !== 0 && !classId) ||
      (groupId !== 0 && !groupId) ||
      (streamId !== 0 && !streamId) ||
      (programId !== 0 && !programId) ||
      !testType
    ) {
      this.testlist = [];
      this.filteredTestList = [];
      return;
    }
    this.services.getIpeTestNames(academicId, classId, groupId, streamId, programId, testType).subscribe({
      next: (res: any) => {
        this.testlist = this.normalizeList(res, ['testNames', 'ipeTestNames', 'tests', 'data']);
        this.testQuery = '';
        this.filteredTestList = [...this.testlist];
      },
      error: () => {
        this.testlist = [];
        this.filteredTestList = [];
        this.toast.showWarning('No tests found for selected filters');
      }
    });
  }

  private clearFromClassDown(): void {
    this.classList = [];
    this.filteredClassList = [];
    this.classQuery = '';
    this.selectedClassName = '';
    this.clearFromGroupDown();
  }

  private clearFromGroupDown(): void {
    this.groupList = [];
    this.filteredGroupList = [];
    this.groupQuery = '';
    this.selectedGroupName = '';
    this.clearFromStreamDown();
  }

  private clearFromStreamDown(): void {
    this.streamList = [];
    this.filteredStreamList = [];
    this.streamQuery = '';
    this.selectedStreamName = '';
    this.clearFromProgramDown();
  }

  private clearFromProgramDown(): void {
    this.programList = [];
    this.filteredProgramList = [];
    this.programQuery = '';
    this.selectedProgramName = '';
    this.clearTestAndBelow();
  }

  private clearTestAndBelow(): void {
    this.testlist = [];
    this.filteredTestList = [];
    this.testQuery = '';
    this.selectedTestCode = '';
    this.selectedtestname = '';
    this.classid = null;
    this.testdate = '';
    this.inputdate = '';
    this.clearBuildingAndSection();
    this.IPEMARKSForm.patchValue({ testCode: '', Building: '', Section: '' });
  }

  private clearBuildingAndSection(): void {
    this.buildingId = null;
    this.selectedBuildingName = '';
    this.buildingQuery = '';
    this.buildinglist = [];
    this.filteredBuildingList = [];
    this.listofsection = [];
    this.filteredSectionList = [];
    this.selectedSectionId = '';
    this.selectedSectionName = '';
    this.sectionQuery = '';
    this.section = '';
    this.noSectionFound = false;
  }

  filterAcademicYears(): void {
    this.filteredAcademicYearList = (this.academicYearList || []).filter((item) =>
      this.matchesQuery(this.getAcademicYearLabel(item), this.academicYearQuery)
    );
  }

  filterClasses(): void {
    this.filteredClassList = (this.classList || []).filter((item) =>
      this.matchesQuery(this.getClassLabel(item), this.classQuery)
    );
  }

  filterGroups(): void {
    this.filteredGroupList = (this.groupList || []).filter((item) =>
      this.matchesQuery(this.getGroupLabel(item), this.groupQuery)
    );
  }

  filterStreams(): void {
    this.filteredStreamList = (this.streamList || []).filter((item) =>
      this.matchesQuery(this.getStreamLabel(item), this.streamQuery)
    );
  }

  filterPrograms(): void {
    this.filteredProgramList = (this.programList || []).filter((item) =>
      this.matchesQuery(this.getProgramLabel(item), this.programQuery)
    );
  }

  filterTestTypes(): void {
    this.filteredTestTypeList = (this.testTypeList || []).filter((item) =>
      this.matchesQuery(this.getTestTypeLabel(item), this.testTypeQuery)
    );
  }

  filterTests(): void {
    const q = (this.testQuery || '').toLowerCase();
    this.filteredTestList = (this.testlist || []).filter((t: any) =>
      this.getApiTestDisplayName(t).toLowerCase().includes(q)
    );
  }

  filterBuildings(): void {
    const q = (this.buildingQuery || '').toLowerCase();
    this.filteredBuildingList = (this.buildinglist || []).filter((b: any) =>
      (b.buildingName || '').toLowerCase().includes(q)
    );
  }

  filterSections(): void {
    const q = (this.sectionQuery || '').toLowerCase();
    this.filteredSectionList = (this.listofsection || []).filter((s: any) =>
      (s.sectionName || '').toLowerCase().includes(q)
    );
  }

  selectAcademicYear(item: any): void {
    const academicYear = this.getAcademicYearLabel(item);
    this.selectedAcademicYear = academicYear;
    this.IPEMARKSForm.patchValue({
      academicYear,
      academicYearId: '',
      className: '',
      classId: '',
      groupName: '',
      groupId: '',
      streamName: '',
      streamId: '',
      programName: '',
      programId: '',
      testCode: '',
      Building: '',
      Section: ''
    });
    this.academicYearQuery = '';
    this.filteredAcademicYearList = [...this.academicYearList];
    this.clearFromClassDown();
    this.loadClasses(academicYear);
  }

  selectClass(item: any): void {
    const classId = this.getClassId(item);
    this.selectedClassName = this.getClassLabel(item);
    this.classid = classId;
    this.IPEMARKSForm.patchValue({
      className: this.selectedClassName,
      classId,
      academicYearId: this.getClassAcademicId(item),
      groupName: '',
      groupId: '',
      streamName: '',
      streamId: '',
      programName: '',
      programId: '',
      testCode: '',
      Building: '',
      Section: ''
    });
    this.classQuery = '';
    this.filteredClassList = [...this.classList];
    this.clearFromGroupDown();
    this.loadGroups(classId);
  }

  selectGroup(item: any): void {
    const groupName = this.getGroupLabel(item);
    const groupId = this.getGroupId(item);
    this.selectedGroupName = groupName;
    this.group = groupName;
    this.IPEMARKSForm.patchValue({
      groupName,
      groupId,
      streamName: '',
      streamId: '',
      programName: '',
      programId: '',
      testCode: '',
      Building: '',
      Section: ''
    });
    this.groupQuery = '';
    this.filteredGroupList = [...this.groupList];
    this.clearFromStreamDown();
    this.loadStreams(groupId);
  }

  selectStream(item: any): void {
    const streamName = this.getStreamLabel(item);
    const streamId = this.getStreamId(item);
    this.selectedStreamName = streamName;
    this.stream = streamName;
    this.IPEMARKSForm.patchValue({
      streamName,
      streamId,
      programName: '',
      programId: '',
      testCode: '',
      Building: '',
      Section: ''
    });
    this.streamQuery = '';
    this.filteredStreamList = [...this.streamList];
    this.clearFromProgramDown();
    this.loadPrograms(streamId);
  }

  selectProgram(item: any): void {
    const programName = this.getProgramLabel(item);
    const programId = this.getProgramId(item);
    this.selectedProgramName = programName;
    this.program = programName;
    this.IPEMARKSForm.patchValue({
      programName,
      programId,
      testCode: '',
      Building: '',
      Section: ''
    });
    this.programQuery = '';
    this.filteredProgramList = [...this.programList];
    this.clearTestAndBelow();
    this.onbuildinglist();
    if (this.IPEMARKSForm.value.testTypeCode || this.IPEMARKSForm.value.testType) {
      this.loadIpeTestNames();
    }
  }

  selectTestType(item: any): void {
    this.selectedTestTypeLabel = this.getTestTypeLabel(item);
    this.IPEMARKSForm.patchValue({
      testType: this.selectedTestTypeLabel,
      testTypeCode: this.getTestTypeApiValue(item),
      testCode: '',
      Building: '',
      Section: ''
    });
    this.testTypeQuery = '';
    this.filteredTestTypeList = [...this.testTypeList];
    this.clearTestAndBelow();
    const v = this.IPEMARKSForm.value;
    if (v.academicYearId && v.classId && v.groupId && v.streamId && v.programId) {
      this.loadIpeTestNames();
    }
  }

  selectTest(test: any): void {
    this.selectedTestCode = test.testCode || test.testId || test.id;
    this.selectedtestname = this.getApiTestDisplayName(test);
    this.testname1 = this.selectedtestname;
    this.classid = test.classId || this.IPEMARKSForm.value.classId;
    this.testdate = test.testStartDate || test.startDate || test.testDate || '';
    this.inputdate = this.testdate;
    this.clearBuildingAndSection();
    this.IPEMARKSForm.patchValue({
      testCode: this.selectedTestCode,
      Building: '',
      Section: ''
    });
    this.onbuildinglist();
  }

  selectBuilding(b: any): void {
    this.buildingId = b.buildingId;
    this.selectedBuildingName = b.buildingName;
    this.selectedSectionId = '';
    this.selectedSectionName = '';
    this.listofsection = [];
    this.filteredSectionList = [];
    this.noSectionFound = false;
    this.IPEMARKSForm.patchValue({ Building: b.buildingId, Section: '' });
    this.loadSections(true);
  }

  selectSection(s: any): void {
    this.selectedSectionId = s.sectionId;
    this.selectedSectionName = s.sectionName;
    this.noSectionFound = false;
    this.class = s.displayName || this.selectedClassName;
    this.group = s.groupName || this.selectedGroupName;
    this.stream = s.streamName || this.selectedStreamName;
    this.program = s.programName || this.selectedProgramName;
    this.section = s.sectionName;
    this.IPEMARKSForm.patchValue({ Section: s.sectionId });
  }

  private loadSections(showToast: boolean): void {
    const loc = this.getIpeLocationParams();
    if (!this.buildingId || !loc.academicId || !loc.classId || !loc.groupId || !loc.streamId || !loc.programId) {
      return;
    }
    this.services.getsectionlist(this.buildingId, loc).subscribe({
      next: (res: any) => {
        this.applySectionList(res, showToast);
        if (this.listofsection.length && this.selectedSectionId) {
          const selectedSection = this.listofsection.find(
            (section: any) => section.sectionId == this.selectedSectionId
          );
          if (selectedSection) {
            this.selectSection(selectedSection);
          }
        }
      },
      error: () => {
        this.applySectionList([], showToast);
      }
    });
  }

  private applySectionList(res: any, showToast: boolean): void {
    this.listofsection = Array.isArray(res) ? res : [];
    this.filteredSectionList = [...this.listofsection];
    this.noSectionFound = this.listofsection.length === 0;
    if (this.noSectionFound) {
      this.selectedSectionId = '';
      this.selectedSectionName = '';
      this.section = '';
      this.IPEMARKSForm.patchValue({ Section: '' });
      if (showToast) {
        this.toast.showWarning('No Section');
      }
    }
    this.cdr.detectChanges();
  }

  onbuildinglist() {
    const loc = this.getIpeLocationParams();
    if (!loc.academicId || !loc.classId || !loc.groupId || !loc.streamId || !loc.programId) {
      this.buildinglist = [];
      this.filteredBuildingList = [];
      return;
    }
    this.services.getipebuilding(loc).subscribe((res: any) => {
      this.buildinglist = this.normalizeBuildingList(res);
      this.filteredBuildingList = [...this.buildinglist];
      if (this.buildingId) {
        const selected = this.buildinglist.find((b: any) => b.buildingId == this.buildingId);
        this.selectedBuildingName = selected?.buildingName || '';
      }
      if (!this.buildinglist.length) {
        this.toast.showWarning('No Building');
      }
    });
  }

  private normalizeBuildingList(res: any): any[] {
    if (Array.isArray(res)) {
      return res;
    }
    if (Array.isArray(res?.campusBuildings)) {
      return res.campusBuildings;
    }
    if (Array.isArray(res?.buildings)) {
      return res.buildings;
    }
    if (Array.isArray(res?.data)) {
      return res.data;
    }
    return [];
  }

  private getIpeLocationParams(): {
    academicId: any;
    classId: any;
    groupId: any;
    streamId: any;
    programId: any;
  } {
    const v = this.IPEMARKSForm?.value || {};
    return {
      academicId: v.academicYearId,
      classId: v.classId,
      groupId: v.groupId,
      streamId: v.streamId,
      programId: v.programId
    };
  }

  /** Inline filter Search — load table only when filter changed. */
  onFilterSearch(): void {
    const v = this.IPEMARKSForm.value;
    if (!v.academicYear) {
      this.toast.showWarning('Please select Academic Year');
      return;
    }
    if (!v.className) {
      this.toast.showWarning('Please select Class');
      return;
    }
    if (!v.groupName) {
      this.toast.showWarning('Please select Group');
      return;
    }
    if (!v.streamName) {
      this.toast.showWarning('Please select Stream');
      return;
    }
    if (!v.programName) {
      this.toast.showWarning('Please select Program');
      return;
    }
    if (!v.testType && !v.testTypeCode) {
      this.toast.showWarning('Please select Test Type');
      return;
    }
    if (!this.selectedTestCode) {
      this.toast.showWarning('Please select Test Name');
      return;
    }
    if (!this.buildingId) {
      this.toast.showWarning('Please select Building');
      return;
    }
    if (this.noSectionFound || !this.listofsection?.length) {
      this.toast.showWarning('No Section');
      return;
    }
    if (!this.selectedSectionId) {
      this.toast.showWarning('Please select Section');
      return;
    }

    this.testname1 = this.selectedtestname;

    const filterKey = `${this.selectedTestCode}|${this.buildingId}|${this.selectedSectionId}`;
    if (this.IPEmarks && filterKey === this.lastLoadedFilterKey) {
      this.collapseFilterAfterSearch();
      return;
    }

    this.subjectVisibility = {};
    this.marksBeforeNc = {};
    this.originalStudentMarks.clear();
    this.studentmarkslist();
    this.collapseFilterAfterSearch();
  }

  private matchesQuery(label: string, query: string): boolean {
    const q = (query || '').toLowerCase().trim();
    if (!q) {
      return true;
    }
    return (label || '').toLowerCase().includes(q);
  }

  private normalizeList(res: any, keys: string[]): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }
    for (const key of keys) {
      if (Array.isArray(res[key])) {
        return res[key];
      }
    }
    return [];
  }

  private normalizeAcademicYearList(res: any): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }
    if (res.academicYear || res.academicId) {
      return [res];
    }
    return this.normalizeList(res, ['academicYears', 'academicYearList', 'years', 'data']);
  }

  getAcademicYearLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return (
      item.academicYear ||
      item.academicYearName ||
      item.year ||
      item.name ||
      item.displayName ||
      item.label ||
      ''
    ).toString();
  }

  getAcademicYearId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.academicId ?? item.academicYearId ?? item.id ?? item.yearId ?? '';
  }

  getClassLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return (
      item.className ||
      item.name ||
      item.displayName ||
      item.class ||
      item.label ||
      ''
    ).toString();
  }

  getClassId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.classId ?? item.id ?? item.classCode ?? '';
  }

  /** Per-class academicId from testCreationbyClasses (Jr/Sr can differ). */
  getClassAcademicId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.academicId ?? item.academicYearId ?? '';
  }

  getGroupLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return (
      item.groupName ||
      item.name ||
      item.displayName ||
      item.group ||
      item.label ||
      ''
    ).toString();
  }

  getGroupId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.groupId ?? item.id ?? item.groupCode ?? '';
  }

  getStreamLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return (
      item.streamName ||
      item.name ||
      item.displayName ||
      item.stream ||
      item.label ||
      ''
    ).toString();
  }

  getStreamId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.streamId ?? item.id ?? item.streamCode ?? '';
  }

  getProgramLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return (
      item.programName ||
      item.name ||
      item.displayName ||
      item.program ||
      item.label ||
      ''
    ).toString();
  }

  getProgramId(item: any): any {
    if (item == null || typeof item === 'string' || typeof item === 'number') {
      return item ?? '';
    }
    return item.programId ?? item.id ?? item.programCode ?? '';
  }

  getTestTypeLabel(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return String(item.testType ?? '');
  }

  getTestTypeApiValue(item: any): string {
    if (item == null) {
      return '';
    }
    if (typeof item === 'string' || typeof item === 'number') {
      return this.toApiTestType(String(item));
    }
    const code = item.testType || item.testTypeCode || item.code || item.name || '';
    return this.toApiTestType(String(code || this.getTestTypeLabel(item)));
  }

  private toApiTestType(value: string): string {
    return (value || '').toString().trim().replace(/\s+/g, '_');
  }

  testname(e: any) {
    // kept for Adm No search dialog compatibility
  }
  filterTestsByMonth(selectedMonth: string): any[] {
    const monthYear = selectedMonth.split('-').join('-');
    return this.testlist.filter((test) =>
      test.testName.includes(monthYear)
    );
  }
  sectionlist(){
    
  }
  onSectionChange(event: any) {
    this.selectedSectionId = event.target.value;
    const selectedSection = this.listofsection.find((section:any) => section.sectionId == this.selectedSectionId);
    if (selectedSection) {
      this.selectSection(selectedSection);
    }
  }
  
  
  openmarksfilterdialog1(){
    if (this.searchDialogRef) {
      return;
    }
    this.data2={
      "date":this.testdate,
      "testname":this.selectedTestCode,
      "buliding":this.buildingId,
      "section":this.selectedSectionId,
      "classid":this.classid,
      "academicId": this.IPEMARKSForm.value.academicYearId,
      "classId": this.IPEMARKSForm.value.classId,
      "groupId": this.IPEMARKSForm.value.groupId,
      "streamId": this.IPEMARKSForm.value.streamId,
      "programId": this.IPEMARKSForm.value.programId
    }
    this.searchDialogRef = this.dialog.open(IpemarksSearchComponent, {
      width: 'min(520px, 92vw)',
      height: '100%',
      maxHeight: '100vh',
      maxWidth: '100%',
      panelClass: ['animate__animated', 'animate__slideInRight', 'ipe-filter-dialog'],
      position: { right: '0' },
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      hasBackdrop: false,
      closeOnNavigation: true,
      data: this.data2
    });
    this.searchDialogRef.afterClosed().subscribe((result: any) => {
      this.searchDialogRef = null;
      if (!result?.saved) {
        return;
      }
      // Prefer existing section; fall back to section from search save
      if (result.selectedTestCode) {
        this.selectedTestCode = result.selectedTestCode;
      }
      if (result.selectedSectionId) {
        this.selectedSectionId = result.selectedSectionId;
      }
      if (result.testdate) {
        this.testdate = result.testdate;
      }
      // Dialog closed after save → reload via testDetails API
      this.studentmarkslist();
    });
  }

  ngOnDestroy(): void {
    this.searchDialogRef?.close();
    this.searchDialogRef = null;
  }
  studentmarkslist() {
    if (!this.selectedTestCode || !this.selectedSectionId) {
      return;
    }
    this.spinner.show()
    this.services.getstudentmarkslist(this.selectedTestCode, this.selectedSectionId).subscribe(res => {
      this.IPEmarks = res

      if (this.IPEmarks === null) {
        this.toast.showWarning('No marks data found');
        this.spinner.hide();
        return;
      }

      this.lastLoadedFilterKey = `${this.selectedTestCode}|${this.buildingId}|${this.selectedSectionId}`;

      // Show test name exactly as returned by API (prefer full name with date range)
      const headers = this.IPEmarks?.headers;
      const apiTestName = this.getApiTestDisplayName(headers) || this.getApiTestDisplayName(this.IPEmarks);
      if (apiTestName) {
        const current = (this.testname1 || '').toString().trim();
        const currentHasRange = / to /i.test(current);
        const apiHasRange = / to /i.test(apiTestName);
        if (!current || apiHasRange || !currentHasRange || apiTestName.length >= current.length) {
          this.testname1 = apiTestName;
          this.selectedtestname = this.testname1;
        }
      }
      this.setColumns(); 
      this.setDataSource(); 
      this.spinner.hide();
    }, error => {
      console.error('Error fetching data:', error);
      this.IPEmarks = null;
      this.spinner.hide();
    });
  }

  /** Exact test name as API returns (with date range fields when present). */
  getApiTestDisplayName(source: any): string {
    if (!source) {
      return '';
    }
    const name = (source.testName || source.examName || source.testname || source.name || '').toString().trim();
    const start = (source.testStartDate || source.startDate || source.fromDate || '').toString().trim();
    const end = (source.testEndDate || source.endDate || source.toDate || '').toString().trim();
    if (name && (/ to /i.test(name) || !start)) {
      return name;
    }
    if (name && start && end) {
      return `${name} ${start} To ${end}`;
    }
    if (name && start) {
      return `${name} ${start}`;
    }
    return name;
  }

  setColumns(): void {
    if (this.IPEmarks?.headers?.testWiseSubjects) {
      // Type the elements in testWiseSubjects
      const testWiseSubjects: { subject: string; maxMarks: number }[] = this.IPEmarks.headers.testWiseSubjects;
  
      this.displayedColumns = ['admNo', 'studentName', ...testWiseSubjects.map((subject) => subject.subject)];
  
      this.displayLabels = {
        admNo: { subjectName: 'Adm No' },
        studentName: { subjectName: 'Student Name' },
        ...testWiseSubjects.reduce(
          (acc: { [key: string]: { subjectName: string; maxMarks: string } }, subject) => {
            acc[subject.subject] = {
              subjectName: subject.subject,
              maxMarks: `Max : ${subject.maxMarks}`
            };
            return acc;
          },
          {}
        )
      };
    }
  }
  setDataSource(): void {
    if (this.IPEmarks?.testWiseStudents) {
      const studentsData = this.IPEmarks.testWiseStudents.map((student:any) => {
        this. studentData = {
          admNo: student.admNo,
          studentName: student.name,
          classId: student.classId ?? student.class_id ?? this.classid ?? this.IPEMARKSForm?.value?.classId
        };
        student.subjects.forEach((subject:any) => {
         this. studentData[subject.subjectName] = { marks: subject.marks };
        });
        return this.studentData;
      });
      this.dataSource.data = studentsData;
      if (this.sort) {
      this.dataSource.sort = this.sort;
      }

      this.adjustTableHeight(studentsData.length);
      this.syncNcHeaderFromData();
      this.captureOriginalMarksSnapshot(studentsData);
    }
    this.spinner.hide()
  }

  /** Store loaded marks so save can detect which students actually changed. */
  private captureOriginalMarksSnapshot(studentsData: any[]): void {
    this.originalStudentMarks.clear();
    const subjects = this.IPEmarks?.headers?.testWiseSubjects || [];
    (studentsData || []).forEach((student: any) => {
      const marks: { [subject: string]: string } = {};
      subjects.forEach((sub: any) => {
        marks[sub.subject] = this.normalizeMarkValue(student[sub.subject]?.marks);
      });
      this.originalStudentMarks.set(String(student.admNo), marks);
    });
  }

  private normalizeMarkValue(marks: any): string {
    if (marks === null || marks === undefined || marks === '') {
      return '';
    }
    const raw = String(marks).trim();
    const upper = raw.toUpperCase();
    if (upper === 'NC' || upper === 'A') {
      return upper;
    }
    const num = Number(raw);
    if (!isNaN(num) && raw !== '') {
      return String(num);
    }
    return raw;
  }

  /** Text marks (NC, A) align left; numeric marks align right. */
  isTextMark(marks: any): boolean {
    const upper = String(marks ?? '').trim().toUpperCase();
    return upper === 'NC' || upper === 'A';
  }

  private isStudentMarksChanged(student: any): boolean {
    const original = this.originalStudentMarks.get(String(student.admNo));
    const subjects = this.IPEmarks?.headers?.testWiseSubjects || [];
    if (!original) {
      return true;
    }
    return subjects.some((sub: any) => {
      if (String(sub.maxMarks) === '0') {
        return false;
      }
      return this.normalizeMarkValue(student[sub.subject]?.marks) !== this.normalizeMarkValue(original[sub.subject]);
    });
  }

  /** Check header NC if every student already has NC for that subject. */
  private syncNcHeaderFromData(): void {
    const subjects = this.IPEmarks?.headers?.testWiseSubjects || [];
    const rows = this.dataSource?.data || [];
    subjects.forEach((sub: any) => {
      const name = sub.subject;
      if (!name || String(sub.maxMarks) === '0') {
        this.subjectVisibility[name] = false;
        return;
      }
      this.subjectVisibility[name] =
        rows.length > 0 &&
        rows.every((row: any) => String(row[name]?.marks ?? '').toUpperCase() === 'NC');
    });
  }

  /** Header NC checkbox: set/clear NC for all students in that subject. */
  onNcHeaderToggle(column: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.subjectVisibility = { ...this.subjectVisibility, [column]: checked };

    (this.dataSource.data || []).forEach((row: any) => {
      if (!row[column]) {
        row[column] = { marks: '' };
      }
      const snapKey = `${row.admNo}|${column}`;
      if (checked) {
        this.marksBeforeNc[snapKey] = row[column].marks;
        row[column].marks = 'NC';
      } else if (Object.prototype.hasOwnProperty.call(this.marksBeforeNc, snapKey)) {
        const prev = this.marksBeforeNc[snapKey];
        row[column].marks = String(prev ?? '').toUpperCase() === 'NC' ? '' : (prev ?? '');
        delete this.marksBeforeNc[snapKey];
      } else {
        // Restore original API marks so user can enter/edit marks again
        row[column].marks = this.getOriginalMarks(row.admNo, column);
      }
    });
    this.dataSource.data = [...this.dataSource.data];
    this.cdr.detectChanges();
  }

  private getOriginalMarks(admNo: any, subject: string): any {
    const student = this.IPEmarks?.testWiseStudents?.find((s: any) => String(s.admNo) === String(admNo));
    const sub = student?.subjects?.find((x: any) => x.subjectName === subject);
    const marks = sub?.marks;
    return marks === 'NC' || marks === 'nc' ? '' : (marks ?? '');
  }

  isSubjectSelected(subjectName: string): boolean {
    return this.subjectVisibility[subjectName] || false;
  }

  /** Entering marks clears column NC and validates. */
  onMarksInput(row: any, subject: string): void {
    const value = String(row[subject]?.marks ?? '').trim().toUpperCase();
    if (this.subjectVisibility[subject] && value !== 'NC') {
      this.subjectVisibility = { ...this.subjectVisibility, [subject]: false };
    }
    // If user typed NC in one cell, don't auto-check header unless all are NC
    if (value !== 'NC' && value !== '') {
      this.validateMarks(row, subject);
    }
    this.syncNcHeaderFromData();
  }

  isSortableColumn(column: string): boolean {
    return column === 'admNo' || column === 'studentName';
  }

  get totalStudentCount(): number {
    return this.dataSource?.data?.length || 0;
  }

  get marksEntryStudentCount(): number {
    return (this.dataSource?.data || []).filter((student: any) => this.hasCompleteMarksEntry(student)).length;
  }

  get pendingStudentCount(): number {
    return Math.max(0, this.totalStudentCount - this.marksEntryStudentCount);
  }

  /** Student has a value (number / NC / A) in every required subject. */
  private hasCompleteMarksEntry(student: any): boolean {
    const subjects = (this.IPEmarks?.headers?.testWiseSubjects || []).filter(
      (sub: any) => String(sub.maxMarks) !== '0'
    );
    if (!subjects.length) {
      return false;
    }
    return subjects.every((sub: any) => this.normalizeMarkValue(student?.[sub.subject]?.marks) !== '');
  }

  getSortIconClass(column: string): string {
    if (!this.sort || this.sort.active !== column) {
      return 'fa-sort';
    }
    if (this.sort.direction === 'asc') {
      return 'fa-sort-asc';
    }
    if (this.sort.direction === 'desc') {
      return 'fa-sort-desc';
    }
    return 'fa-sort';
  }

  onSortChange(): void {
    this.cdr.detectChanges();
  }
getMaxMarks(subject: string): number {
  const subjectData = this.IPEmarks?.headers?.testWiseSubjects.find(
      (subjectObj: any) => subjectObj.subject === subject
  );
  return subjectData ? +subjectData.maxMarks : 0;
}

// Validate marks to ensure they do not exceed max marks or invalid characters
validateMarks(row: any, subject: string): void {
    let marks = row[subject].marks;

    // Check if input is numeric or empty (invalid inputs are ignored)
    if (isNaN(parseFloat(marks)) && marks !== '') {
      return;
    }
    if (!isNaN(parseFloat(marks))) {
      marks = parseFloat(marks);
      const maxMarks = this.getMaxMarks(subject);
      const maxDigits = maxMarks < 10 ? 1 : maxMarks < 100 ? 2 : 3;
      if (marks.toString().length > maxDigits) {
        this.toast.showError(`Entered marks should not exceed the maximum marks ${maxMarks} for ${subject} `)
        this.focusInvalidInput(row, subject);
        marks
        return;
      }
      if (marks > maxMarks) {
        row[subject].marks = maxMarks;
        this.toast.showError(`Entered marks should not exceed the maximum marks ${maxMarks} for ${subject} `)
        this.focusInvalidInput(row, subject);
        row[subject].marks =""
      } else {
        row[subject].marks = marks;
      }
    }
  }

// Restrict input to valid characters and strings for marks input fields
restrictInvalidCharacters(event: KeyboardEvent): void {
  const allowedStrings = ['a', 'n', 'c'];
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];

  if (
      !/^\d$/.test(event.key) && // Allow digits
      !allowedKeys.includes(event.key) && // Allow navigation keys
      !allowedStrings.includes(event.key.toLowerCase()) && // Allow certain letters
      !this.isValidMultiCharInput(event) // Handle "nc" input
  ) {
      event.preventDefault(); // Prevent invalid characters
  }
}
focusInvalidInput(row: any, subject: string): void {
  setTimeout(() => {
    if (!this.inputRefs || this.inputRefs.length === 0) {
      console.error('inputRefs is not initialized or empty');
      return;
    }

    const inputElements = this.inputRefs.toArray();

    const invalidInput = inputElements.find(
      (input) =>
        input.nativeElement.getAttribute('data-adm-no') === String(row.admNo) &&
        input.nativeElement.getAttribute('data-subject') === subject
    );

    if (invalidInput && invalidInput.nativeElement) {
      invalidInput.nativeElement.focus();
    } else {
      console.error(
        `Unable to find input for admNo: ${row.admNo}, subject: ${subject}`
      );
    }
  }, 50);
 }
isValidMultiCharInput(event: KeyboardEvent): boolean {
  const inputValue = event.target as HTMLInputElement;
  const currentValue = inputValue.value.toLowerCase();

  // Allow "nc" input by detecting "n" followed by "c"
  return currentValue.endsWith('n') && event.key.toLowerCase() === 'c';
}
  getSubjectMarks(row: any, subjectName: string): number | string {
    const subject = row.subjects.find((sub: any) => sub.subjectName === subjectName);
    return subject ? subject.marks : ''; // Return empty string if not found
  }
  setSubjectMarks(row: any, subjectName: string, value: number | string): void {
    const subject = row.subjects.find((sub: any) => sub.subjectName === subjectName);
    if (subject) {
      subject.marks = value; // Update the marks in the data structure
    }
  }

  onMarksChange(column: string, row: any, event: any): void {
    console.log(`Marks for ${column} changed to ${event.target.value} for student ${row.studentName}`);
    row[column].marks = event.target.value;
  }

  checkMaxMarks(subject: string, marks: number): boolean {
    const maxMarks = this.testWiseSubjects.find((sub:any) => sub.subject === subject)?.maxMarks;
    return maxMarks ? marks <= maxMarks : true;
  }
  getMaxLength(column: string): number {
    const maxMarks = this.getMaxMarks(column);
    return maxMarks < 10 ? 1 : maxMarks < 100 ? 2 : 3;
  }
  submitMarks(): void {
    if (!this.hasStudentMarksChanges) {
      this.toast.showWarning('Enter marks for at least one student');
      return;
    }
    const changedStudents = (this.dataSource.data || []).filter((student: any) =>
      this.isStudentMarksChanged(student)
    );

    if (!changedStudents.length) {
      this.toast.showWarning('No changes to save');
      return;
    }

    // Validate only students that were updated
    for (const student of changedStudents) {
      for (const subject of this.IPEmarks.headers.testWiseSubjects) {
        // Skip validation if maxMarks is 0 (read-only fields)
        if (subject.maxMarks === '0' || String(subject.maxMarks) === '0') {
          continue;
        }

        const marks = student[subject.subject]?.marks;
        if (marks === '' || marks === null || marks === undefined) {
          this.toast.showError(`Please enter marks for ${student.admNo} - ${subject.subject}`);
          this.focusInvalidInput(student, subject.subject);
          return;
        }
      }
    }

    const submitData = {
      ipeMarks: {
        testDate: String(this.testdate || this.inputdate || ''),
        testCode: String(this.selectedTestCode || ''),
        sectionId: String(this.selectedSectionId || ''),
        students: changedStudents.map((student: any) => ({
          admNo: String(student.admNo ?? ''),
          classId: this.resolveStudentClassId(student),
          subjects: this.IPEmarks.headers.testWiseSubjects.map((subject: any) => ({
            subject: String(subject.subject ?? ''),
            marks: this.markPayloadValue(student[subject.subject]?.marks)
          }))
        }))
      }
    };

    if (confirm(`Total Students: ${this.dataSource.data.length} / Updated Students: ${changedStudents.length}\n\nDo you want to Save IPE marks?`)) {
      this.spinner.show();
      this.services.saveStudentMarks(submitData).subscribe({
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
            return;
          }
          this.students = res;
          if (this.students.toString().includes('not')) {
          this.toast.showWarning(res.toString());
            this.spinner.hide();
            return;
          }
          this.toast.showSuccess(res.message || 'IPE marks Saved Successfully.');
          // After save success → reload marks from testDetails API
          this.studentmarkslist();
        },
        error: (err) => {
          console.error('Save IPE marks failed', err);
          this.toast.showError('Save failed. Please try again.');
          this.spinner.hide();
        }
      });
    }
  }
  private markPayloadValue(marks: any): string {
    if (marks === null || marks === undefined || marks === '') {
      return '';
    }
    const raw = String(marks).trim();
    const upper = raw.toUpperCase();
    if (upper === 'NC' || upper === 'A') {
      return upper;
    }
    return raw;
  }

  private resolveStudentClassId(student?: any): number {
    const n = Number(student?.classId ?? this.classid ?? this.IPEMARKSForm?.value?.classId);
    return Number.isFinite(n) ? n : 0;
  }

  isExceedingMaxMarks(row: any, subject: string): boolean {
    return Number(row[subject].marks) > this.getMaxMarks(subject);
  }
  resetFormFields(): void {
    this.dataSource.data.forEach((student: any) => {

      this.IPEmarks.headers.testWiseSubjects.forEach((subject: any) => {
        student[subject.subject].marks = '';
      });
    });
    this.dataSource._updateChangeSubscription();
  }

  ngAfterViewInit() {
    if (this.sort) {
    this.dataSource.sort = this.sort;
    }
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
     // Remove whitespace and make lowercase
     const filteredData = this.dataSource.filteredData; // Access the filtered data
     this.adjustTableHeight(filteredData.length);
  }
  adjustTableHeight(rowCount: number): void {
    const ROW_HEIGHT = 36;         // Compact row height
  const HEADER_FOOTER_HEIGHT = 50; // Additional height for header/footer
  const MAX_HEIGHT = 700;       // Maximum height for scrolling
  
  if (rowCount === 0) {
    this.tableHeight = '130px'; // Minimum height for no records
  } else if (rowCount === 1) {
    this.tableHeight = `${ROW_HEIGHT + HEADER_FOOTER_HEIGHT}px`; // Adjust height for one record + footer
  } else {
    const calculatedHeight = rowCount * ROW_HEIGHT + HEADER_FOOTER_HEIGHT; // Calculate height for multiple rows
    if (calculatedHeight <= MAX_HEIGHT) {
      this.tableHeight = `${calculatedHeight}px`; // Set height without scrolling
    } else {
      this.tableHeight = `${MAX_HEIGHT}px`; // Set height with scrolling
    }
  }
  }

}
